/*
THIS INFRAGISTICS ULTIMATE SOFTWARE LICENSE  AGREEMENT ("AGREEMENT") LOCATED HERE:
https://www.infragistics.com/legal/license/igultimate-la
https://www.infragistics.com/legal/license/igultimate-eula
GOVERNS THE LICENSING, INSTALLATION AND USE OF INFRAGISTICS SOFTWARE. BY DOWNLOADING AND/OR INSTALLING AND USING INFRAGISTICS SOFTWARE:  you are indicating that you have read and understand this Agreement, and agree to be legally bound by it on behalf of the yourself and your company.
*/
import { markEnum } from "igniteui-react-core";
export var SortIndicatorStyle = /*@__PURE__*/ (function (SortIndicatorStyle) {
    /**
     * The sort indicator is rendered as a single arrow that points in the direction of the sort.
     */
    SortIndicatorStyle[SortIndicatorStyle["Default"] = 0] = "Default";
    /**
     * The sort indicator is rendered as two arrows pointing opposite of each other.  The direction of the sort determines which arrow
     * is faded and which is fully opaque.
     */
    SortIndicatorStyle[SortIndicatorStyle["FadingUpDownArrows"] = 1] = "FadingUpDownArrows";
    /**
     * The sort indicator is rendered as two arrows without the stem, one ontop of the other.  The direction of the sort determines which arrow
     * is faded and which is fully opaque.
     */
    SortIndicatorStyle[SortIndicatorStyle["FadingSimpleUpDownArrows"] = 2] = "FadingSimpleUpDownArrows";
    /**
     * No style is set.
     */
    SortIndicatorStyle[SortIndicatorStyle["Unset"] = 3] = "Unset";
    return SortIndicatorStyle;
})({});
/**
 * @hidden
 */
export var SortIndicatorStyle_$type = /*@__PURE__*/ markEnum('SortIndicatorStyle', 'Default,0|FadingUpDownArrows,1|FadingSimpleUpDownArrows,2|Unset,3');
//# sourceMappingURL=SortIndicatorStyle.js.map
